<script lang="ts">
  // What a bucket of activity was made of, as one labelled row per number. Shared by the
  // two activity hovers so a DAY on `<Heatmap>` and a WEEK on `<ActivityStrip>` report the
  // same three things in the same words, the same order and the same formatting — they
  // were two copies of this markup, which is how one of them ends up saying "upvotes"
  // while the other says "likes".
  //
  // Sits beside `<RoleBreakdown>`, the other thing a tooltip renders inside itself.
  let {
    posts = 0,
    comments = 0,
    likes = null,
  }: {
    // `| undefined` spelled out because the project runs `exactOptionalPropertyTypes`:
    // both callers read these straight off an optional wire field, so they pass an
    // explicit `undefined` rather than omitting the prop.
    posts?: number | undefined;
    comments?: number | undefined;
    /** Upvotes on the content written in this bucket. Null/undefined is omitted rather
     *  than shown as zero — a payload that predates the field is not a claim that nobody
     *  liked anything. */
    likes?: number | null | undefined;
  } = $props();

  const rows = $derived([
    { label: 'posts', value: posts ?? 0 },
    { label: 'comments', value: comments ?? 0 },
    ...(likes == null ? [] : [{ label: 'likes', value: likes }]),
  ]);
</script>

<div class="mt-1 space-y-0.5 text-xs text-base-content/70">
  {#each rows as row (row.label)}
    <div class="flex justify-between gap-3">
      <span>{row.label}</span>
      <span class="font-mono font-semibold tabular-nums text-base-content"
        >{row.value.toLocaleString()}</span
      >
    </div>
  {/each}
</div>
